import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInAsExecutive } from '../lib/executiveAuth';
import { LogIn, AlertTriangle, Building2, Shield } from 'lucide-react';

const CEOLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAdminLogin = async () => {
    try {
      setLoading(true);
      setError('');
      
      const result = await signInAsExecutive();
      
      if (result.success) {
        navigate('/executive-dashboard');
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err: any) {
      setError(err.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-avn-purple-900 to-avn-purple-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8">
        <div className="text-center mb-6">
          <div className="inline-flex bg-avn-purple-100 p-3 rounded-full mb-4">
            <Building2 className="h-8 w-8 text-avn-purple-600" />
          </div>
          <h1 className="text-2xl font-bold mb-2">AVN Executive Portal</h1>
          <p className="text-gray-600">Access the CEO dashboard and management tools</p>
        </div>
        
        <div className="bg-avn-purple-50 border border-avn-purple-200 rounded-lg p-4 mb-6">
          <div className="flex items-start gap-2">
            <Shield className="h-5 w-5 text-avn-purple-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-avn-purple-700 font-medium">Executive Access</p>
              <p className="text-sm text-avn-purple-600 mt-1">
                This portal provides access to sensitive organizational data and controls. 
                Only authorized personnel should proceed.
              </p>
            </div>
          </div>
        </div>
        
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6 flex items-center">
            <AlertTriangle className="h-5 w-5 mr-2 flex-shrink-0" />
            <span>{error}</span>
          </div>
        )}
        
        <button
          onClick={handleAdminLogin}
          disabled={loading}
          className="w-full bg-avn-purple-600 text-white py-3 px-6 rounded-lg font-medium flex items-center justify-center gap-2 hover:bg-avn-purple-700 transition-colors disabled:opacity-70 mb-6"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
              <span>Logging in...</span>
            </>
          ) : (
            <>
              <LogIn className="h-5 w-5" />
              <span>Sign in as CEO</span>
            </>
          )}
        </button>
        
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-gray-700 text-sm font-medium mb-2">Account Details:</p>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div className="text-gray-600">Email:</div>
            <div className="font-medium">hamza@avnearth.com</div>
            
            <div className="text-gray-600">Password:</div>
            <div className="font-medium">AVNhamza2025!</div>
            
            <div className="text-gray-600">Role:</div>
            <div className="font-medium">Chief Executive Officer</div>
            
            <div className="text-gray-600">Access Level:</div>
            <div className="font-medium text-avn-purple-600">Full Administrative</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CEOLoginPage;